import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function TermsPage() {
  return <LegalLayout title="Termos de Uso" lastUpdated="04 de maio de 2026" data-id="element-856">
      <Section title="1. Sobre a Aurora" data-id="element-857">
        <p data-id="element-858">
          A Aurora é uma plataforma de gestão financeira destinada a
          confeiteiras, doceiras e artesãs brasileiras, com sede em São Paulo,
          SP ("a Aurora", "nós", "nossa").
        </p>
        <p data-id="element-859">
          Ao criar uma conta e utilizar a Aurora, você ("Usuária") concorda
          integralmente com estes Termos de Uso.
        </p>
      </Section>

      <Section title="2. Elegibilidade" data-id="element-860">
        <p data-id="element-861">
          A Aurora é destinada a pessoas físicas maiores de 18 anos que exerçam
          atividades de confeitaria, doceria ou artesanato. Ao se cadastrar,
          você declara que atende a esses requisitos.
        </p>
      </Section>

      <Section title="3. Conta e acesso" data-id="element-862">
        <p data-id="element-863">
          3.1. Você é responsável por manter a confidencialidade de suas
          credenciais de acesso (email e senha).
        </p>
        <p data-id="element-864">
          3.2. Você é responsável por todas as atividades realizadas em sua
          conta.
        </p>
        <p data-id="element-865">
          3.3. Em caso de suspeita de acesso não autorizado, notifique-nos
          imediatamente em{' '}
          <a href="mailto:suporte@myaurora.com.br" data-id="element-866">suporte@myaurora.com.br</a>.
        </p>
        <p data-id="element-867">
          3.4. Reservamo-nos o direito de suspender ou encerrar contas que
          violem estes Termos.
        </p>
      </Section>

      <Section title="4. Planos e pagamentos" data-id="element-868">
        <p data-id="element-869">4.1. A Aurora oferece dois planos de assinatura:</p>
        <ul data-id="element-870">
          <li data-id="element-871">Plano Mensal: R$ 29,90/mês</li>
          <li data-id="element-872">Plano Anual: R$ 289,00/ano</li>
        </ul>
        <p data-id="element-873">
          4.2. Os pagamentos são processados pela Hotmart. Ao assinar, você
          concorda também com os termos de pagamento da Hotmart.
        </p>
        <p data-id="element-874">
          4.3. As cobranças são recorrentes e automáticas conforme o plano
          escolhido.
        </p>
        <p data-id="element-875">
          4.4. Preços podem ser alterados com aviso prévio de 30 dias por email.
        </p>
      </Section>

      <Section title="5. Cancelamento e reembolso" data-id="element-876">
        <p data-id="element-877">
          5.1. Você pode cancelar sua assinatura a qualquer momento, sem multa,
          diretamente pela Hotmart ou solicitando em{' '}
          <a href="mailto:suporte@myaurora.com.br" data-id="element-878">suporte@myaurora.com.br</a>.
        </p>
        <p data-id="element-879">
          <strong data-id="element-880">5.2. Garantia incondicional de 7 dias:</strong> se você não
          ficar satisfeita nos primeiros 7 dias após a primeira compra,
          devolveremos 100% do valor pago, sem perguntas.
        </p>
        <p data-id="element-881">
          5.3. Após o período de garantia, não há reembolso de valores já
          cobrados, mas o cancelamento impede futuras cobranças e mantém o
          acesso até o fim do ciclo já pago.
        </p>
        <p data-id="element-882">
          5.4. Em caso de cancelamento, seus dados ficam preservados por 30 dias
          caso você decida reativar. Após esse prazo, podem ser permanentemente
          excluídos.
        </p>
      </Section>

      <Section title="6. Uso aceitável" data-id="element-883">
        <p data-id="element-884">Você concorda em NÃO:</p>
        <ul data-id="element-885">
          <li data-id="element-886">Compartilhar suas credenciais com terceiros</li>
          <li data-id="element-887">Utilizar a Aurora para atividades ilegais</li>
          <li data-id="element-888">
            Tentar invadir, interferir ou comprometer o funcionamento da
            plataforma
          </li>
          <li data-id="element-889">Realizar engenharia reversa, copiar ou redistribuir o código</li>
          <li data-id="element-890">Usar a Aurora para enviar spam ou conteúdo malicioso</li>
          <li data-id="element-891">Criar múltiplas contas para burlar limites ou pagamentos</li>
        </ul>
      </Section>

      <Section title="7. Conteúdo da Usuária" data-id="element-892">
        <p data-id="element-893">
          7.1. Todos os dados que você insere na Aurora (matérias-primas,
          produtos, pacotes, pedidos, configurações) são de sua propriedade.
        </p>
        <p data-id="element-894">
          7.2. Concedemos a você uma licença limitada para usar a Aurora, mas
          todos os direitos sobre o software, marca, design e funcionalidades
          permanecem nossos.
        </p>
        <p data-id="element-895">
          7.3. Você pode exportar seus dados a qualquer momento via
          funcionalidade nas Configurações da conta.
        </p>
      </Section>

      <Section title="8. Disponibilidade do serviço" data-id="element-896">
        <p data-id="element-897">
          8.1. Faremos esforços razoáveis para manter a Aurora disponível 24/7,
          mas não garantimos disponibilidade ininterrupta.
        </p>
        <p data-id="element-898">
          8.2. Podemos realizar manutenções programadas com aviso prévio quando
          possível.
        </p>
        <p data-id="element-899">
          8.3. Não nos responsabilizamos por interrupções causadas por terceiros
          (provedores de hospedagem, internet, gateways de pagamento).
        </p>
      </Section>

      <Section title="9. Limitação de responsabilidade" data-id="element-900">
        <p data-id="element-901">
          9.1. A Aurora é uma ferramenta de gestão. As decisões de negócio
          (preços, margens, custos) são de responsabilidade exclusiva da
          Usuária.
        </p>
        <p data-id="element-902">
          9.2. Não nos responsabilizamos por perdas financeiras decorrentes de
          decisões tomadas com base nos cálculos da plataforma.
        </p>
        <p data-id="element-903">
          9.3. Recomendamos validar informações importantes com contadores ou
          profissionais qualificados.
        </p>
        <p data-id="element-904">
          9.4. Em qualquer hipótese, nossa responsabilidade total fica limitada
          ao valor pago pela Usuária nos últimos 12 meses.
        </p>
      </Section>

      <Section title="10. Alterações nos Termos" data-id="element-905">
        <p data-id="element-906">
          10.1. Podemos atualizar estes Termos a qualquer momento. Mudanças
          significativas serão comunicadas por email com pelo menos 15 dias de
          antecedência.
        </p>
        <p data-id="element-907">
          10.2. O uso continuado da Aurora após as alterações constitui
          aceitação dos novos Termos.
        </p>
      </Section>

      <Section title="11. Encerramento" data-id="element-908">
        <p data-id="element-909">
          11.1. Você pode encerrar sua conta a qualquer momento via
          Configurações &gt; Excluir conta, ou solicitando em{' '}
          <a href="mailto:suporte@myaurora.com.br" data-id="element-910">suporte@myaurora.com.br</a>.
        </p>
        <p data-id="element-911">
          11.2. Podemos encerrar sua conta em caso de violação destes Termos,
          com notificação prévia quando aplicável.
        </p>
        <p data-id="element-912">
          11.3. Após o encerramento, todos os dados são permanentemente
          excluídos em até 30 dias, exceto quando exigido por lei mantê-los.
        </p>
      </Section>

      <Section title="12. Lei aplicável e foro" data-id="element-913">
        <p data-id="element-914">12.1. Estes Termos são regidos pela legislação brasileira.</p>
        <p data-id="element-915">
          12.2. Fica eleito o foro da Comarca de São Paulo, SP, para dirimir
          qualquer controvérsia, com renúncia a qualquer outro, por mais
          privilegiado que seja.
        </p>
      </Section>

      <Section title="13. Contato" data-id="element-916">
        <p data-id="element-917">Para dúvidas, sugestões ou solicitações:</p>
        <ul data-id="element-918">
          <li data-id="element-919">
            Email:{' '}
            <a href="mailto:suporte@myaurora.com.br" data-id="element-920">suporte@myaurora.com.br</a>
          </li>
          <li data-id="element-921">
            Site:{' '}
            <a href="https://myaurora.com.br" target="_blank" rel="noreferrer" data-id="element-922">
              myaurora.com.br
            </a>
          </li>
        </ul>
      </Section>
    </LegalLayout>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-923">
      <h2 className="font-serif font-bold text-xl md:text-2xl text-ink mb-4 mt-2" data-id="element-924">
        {title}
      </h2>
      <div className="space-y-3 text-[15px] md:text-[16px] leading-[1.7] text-ink-soft" data-id="element-925">
        {children}
      </div>
    </section>;
}